import '../controllers'

import '../apps/filter'
import '../apps/favorites'

document.addEventListener('DOMContentLoaded', () => {
  window.addEventListener('scroll', window.Burobiz.throttle(() => { window.Burobiz.StickyBtn.scrollCheck() }, 900))
})
